import { Controller, useFormContext } from "react-hook-form";
import { toFixed } from "../../../../../../utils/numberMethods";

interface props {
  where: string;
}

export default function SubTotalCostControl({ where }: props) {
  const { control, setValue, getValues } = useFormContext();

  const handleChange = (subTotal: number) => {
    const supply = toFixed(subTotal / 1.1, 0);
    const gst = toFixed(subTotal - supply, 0);

    if (getValues()[`${where}Supply`] !== supply) {
      setValue(`${where}Supply`, supply);
    }
    if (getValues()[`${where}Gst`] !== gst) {
      setValue(`${where}Gst`, gst);
    }

    const { installSubTotal, productSubTotal } = getValues();
    const otherSubTotal =
      where == "product" ? installSubTotal : productSubTotal;

    const total = Number(otherSubTotal) + subTotal;

    if (getValues().total !== total) {
      setValue("total", total);
    }
  };

  return (
    <Controller
      control={control}
      name={`${where}SubTotal`}
      render={({ field }) => (
        <input
          {...field}
          onChange={e => {
            field.onChange(e);
            handleChange(Number(e.target.value));
          }}
          type="number"
          className="text-center bg-gray-100"
        />
      )}
    />
  );
}
